import themeMapper from '@gravity/theme-mapper';
import merge from 'lodash/merge';

//
function theme(style) {
  // get the theme from the equilibrium properties
  const defaultTheme = themeMapper(style);
  // get the theme for the current widget , values specific to the widget
  const widgetTheme = {
    tsFooter: {
      backgroundImage: defaultTheme.footerBgImage,
      backgroundColor: defaultTheme.footerBgColor,
      color: defaultTheme.footerTextColor,
    },
    advantageCode: {
      backgroundColor: defaultTheme.innerBoxBgColor || '#e6e6e6',
      textColor: defaultTheme.heading.textColor,
    },
    filmStrip: {
      iconColor: '#000000',
    },
    catalog: {
      backgroundColor: defaultTheme.boxBgColor,
    },
  };
  // Merge the basic style to be backward compatible, but it should disappear later
  return merge(defaultTheme, widgetTheme, style);
}

export default theme;
